import { useNavigate } from 'react-router-dom';

import { useNavigationProgress } from '@repo/ui/navigation-progress';

export const useProgressRouter = () => {
  const navigate = useNavigate();
  const { startNavigation } = useNavigationProgress();

  return {
    push: (url: string) => {
      startNavigation();
      navigate(url);
    },
    back: () => {
      startNavigation();
      navigate(-1);
    },
    replace: (url: string, _options?: { scroll?: boolean }) => {
      navigate(url, { replace: true });
    },
  };
};
